import React from "react";

const CHECKOUT_URL = "https://gillesdelieuze.com/stop-syndrome-imposteur-bdc/";

export default function CheckoutButton({
  children,
  className = "",
  testId = "checkout-button",
  showArrow = false,
}) {
  return (
    <a
      href={CHECKOUT_URL}
      target="_blank"
      rel="noopener noreferrer"
      data-testid={testId}
      className={
        "group relative inline-flex items-center justify-center gap-3 " +
        "bg-gold text-obsidian font-display uppercase tracking-[0.18em] " +
        "px-8 md:px-10 py-4 md:py-5 text-sm md:text-base rounded-full " +
        "transition-all duration-300 ease-out " +
        "hover:bg-gold-hover hover:-translate-y-0.5 active:translate-y-0 " +
        "no-underline " +
        "gold-glow gold-glow-hover " +
        className
      }
    >
      <span>{children}</span>
      {showArrow && (
        <span className="transition-transform group-hover:translate-x-1">
          →
        </span>
      )}
    </a>
  );
}
